import { render, staticRenderFns } from "./RankingClose.vue?vue&type=template&id=604dc3fd&scoped=true&"
import script from "./RankingClose.vue?vue&type=script&lang=js&"
export * from "./RankingClose.vue?vue&type=script&lang=js&"
import style0 from "./RankingClose.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingClose.vue?vue&type=style&index=1&id=604dc3fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604dc3fd",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingClose.vue"
export default component.exports